import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { useMutation } from "@apollo/client";
import { Formik, Form, Field, useFormik } from "formik";

import { Organization } from "../../../Components/AutoSuggest/Organization/Organization";
import { TOKEN } from "../../../Utils/constant";
import * as auth from "../_redux/authRedux";
import { SET_WORKER_COMPANY } from "../mutations/index";

import { useOrganizationJoinValidationSchema } from "./useOrganizationJoinValidationSchema";

export default function OrganizationJoin() {
  const { initialValues, organizationJoinValidationSchema } = useOrganizationJoinValidationSchema();

  const [actionsLoading, setActionsLoading] = useState(false);

  const [
    companySubmit,
    { loading: companyLoading, error: companyError, data },
  ] = useMutation(SET_WORKER_COMPANY);

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: organizationJoinValidationSchema,
  });

  useEffect(() => {
    if (companyLoading) {
      setActionsLoading(true);
      formik.setStatus("");
    }

    if (companyError) {
      setActionsLoading(false);
      formik.setStatus(companyError.toString().replace("Error: Error:", ""));
    }

    if (data) {
      const token = window.localStorage.getItem(TOKEN);

      const user = JSON.parse(window.localStorage.getItem("user"));

      dispatch(auth.actions.login(token));
      dispatch(
        auth.actions.fulfillUser({
          ...user,
          username: user.firstName,
          fullname: user.firstName,
        }),
      );
    }
  }, [companyLoading, companyError, data, formik, dispatch]);

  const saveCompany = (company, setSubmitting) => {
    companySubmit({
      variables: {
        name: company.companyName,
      },
    });
    setSubmitting(false);
  };

  return (
    <Modal size="lg" show={true} aria-labelledby="example-modal-sizes-title-lg">
      <>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={organizationJoinValidationSchema}
          onSubmit={(values, { setSubmitting }) => {
            saveCompany(values, setSubmitting);
          }}
        >
          {({ handleSubmit }) => (
            <>
              <Modal.Header>
                <h3>Company</h3>
              </Modal.Header>
              <Modal.Body className="overlay overlay-block cursor-default">
                {actionsLoading && (
                  <div className="overlay-layer bg-transparent">
                    <div className="spinner spinner-lg spinner-success" />
                  </div>
                )}
                {formik.status && (
                  <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                    <div className="alert-text font-weight-bold">
                      {formik.status}
                    </div>
                  </div>
                )}
                <Form className="form form-label-right">
                  <div className="form-group row">
                    {/* Organization Name */}
                    <div className="col-lg-6">
                      <Field
                        name="companyName"
                        component={Organization}
                        placeholder="OrganizationName"
                        label="Organization Name"
                      />
                    </div>
                  </div>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={formik.isSubmitting}
                  className={
                    "btn btn-primary btn-elevate font-weight-bold px-9 py-4"
                  }
                >
                  Submit
                  {actionsLoading && (
                    <span className="ml-3 spinner spinner-white"></span>
                  )}
                </button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </>
    </Modal>
  );
}
